import { PnkAjax } from '../pnk-react/ajax/pnk-ajax';

// function CheckToken(resp) {

//     // let timeToLogout = (new Date((localStorage.getItem('login_token_expire_time')))).getTime() - (new Date()).getTime();
//     // alert(timeToLogout)
//     // setTimeout(() => {
//     //     localStorage.clear();
//     //     // window.location.reload();
//     //     resp(false);
//     // }, timeToLogout);
// }

//kinship

// to register the new user

export function AddUser(store, userObj, successFunc) {
    //code for further validations
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    return PnkAjax(store).Post('register/json').ExtraData(userObj).AttachLoader(loader).OnSuccess(successFunc).Do();
}

// login route

export function LoginUser(store, userObj, successFunc) {
    //code for further validations
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    return PnkAjax(store).Post('login/json').ExtraData(userObj).AttachLoader(loader).OnSuccess(successFunc).Do();
}

// social login route

export function SocialLogin(store, userObj, successFunc) {
    //code for further validations
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    return PnkAjax(store).Post('sociallogin/json').ExtraData(userObj).AttachLoader(loader).OnSuccess(successFunc).Do();
}

// forget password route

export function ForgotPassword(store, userObj, successFunc) {

    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    return PnkAjax(store).Post('forgetpasswordlink/json').ExtraData(userObj).AttachLoader(loader).OnSuccess(successFunc).Do();
}

// create organizer route

export function AddOrganizerData(store, userObj, successFunc) {

    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    return PnkAjax(store).Post('organizers/json').ExtraData(userObj).AttachLoader(loader).OnSuccess(successFunc).Do();
}

// get all users list route

export function GetUsersList(store, successFunc) {
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    // if (!(store.GetData('userlist').length == 0)) {
    return PnkAjax(store).Get('users/json').AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
    // }
    // else return HandleSuccessGetUserList(store.GetData('userlist'), store);
}

// get user by its id

export function UserDetail(store, user_id, successFunc) {
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    // if (!(store.GetData('userlist').length == 0)) {
    return PnkAjax(store).Get('user/json/' + user_id).AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
    // }
    // else return HandleSuccessGetUserList(store.GetData('userlist'), store);
}

// update user by its id

export function UpdateUserDetail(store, user_id,editObj,successFunc) {
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    // if (!(store.GetData('userlist').length == 0)) {
    return PnkAjax(store).Put('user/json/' + user_id).ExtraData(editObj).AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
    // }
    // else return HandleSuccessGetUserList(store.GetData('userlist'), store);
}

// Contact us message api

export function ContactUs(store, userObj, successFunc) {

    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    return PnkAjax(store).Post('/contact').ExtraData(userObj).AttachLoader(loader).OnSuccess(successFunc).Do();
}


// get all organizer list route

export function GetOrganizersList(store, successFunc) {
    //  alert(localStorage.getItem('current_user_login_token'))
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    // if (!(store.GetData('userlist').length == 0)) {
    return PnkAjax(store).Get('organizers/json').AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
    // }
    // else return HandleSuccessGetUserList(store.GetData('userlist'), store);
}

// get organizer details route

export function OrganizerDetails(store, organizer_id, successFunc) {
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    // if (!(store.GetData('userlist').length == 0)) {
    return PnkAjax(store).Get('organizer/json/' + organizer_id).AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
    // }
    // else return HandleSuccessGetUserList(store.GetData('userlist'), store);
}

// update organizer details route

export function UpdateOrganizerDetails(store, organizer_id, editObj, successFunc) {
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    // if (!(store.GetData('userlist').length == 0)) {
    return PnkAjax(store).Put('organizer/json/' + organizer_id).ExtraData(editObj).AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
    // }
    // else return HandleSuccessGetUserList(store.GetData('userlist'), store);
}



